import { useState, lazy, Suspense, useCallback, useEffect } from 'react';
import { useRouter } from 'next/router';
import s from './style.module.scss';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import GoogleLoginButton from './googleLoginButton';
import AppleLoginButton from './appleLoginButton';
import Link from 'next/link';
import { useStores } from '../../stores/storeContext';
// import { useSmallWindow } from '../../hooks/useSmallScreen';

// 驼峰命名转蛇形命名（用于 URL 路径）
const camelToSnake = (str) => str.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);

function LogIn(props = { appType: 'duet' }) {
  const isWing = props?.appType === 'wing';
  const isRetrieveData = props?.scene === 'retrieve-data';
  // const [isMobile] = useSmallWindow(); // 用于判断屏幕宽度
  const { t } = useTranslation();
  const router = useRouter();
  const { rootStore: { updateKey } } = useStores();

  // 将入口场景存入 store，供后续 phone/verifyPhone 组件使用
  useEffect(() => {
    if (props?.scene) {
      updateKey('scene', props.scene);
    }
  }, [props?.scene]);

  const handleEntry = useCallback((entry) => {
    router.push(`${isWing ? '/wing' : ''}/log-entries/${camelToSnake(entry)}`);
  }, []);

  return (
    <div className={s.wrapper}>
      <div className={isWing ? s.icon1 : s.icon} />
      <div className={s.title}>
        {isRetrieveData
          ? t('OMI_DATA_DOWNLOAD_RETRIEVE_TITLE')
          : t('DUET_H5_ACCOUNT_MANAGE_MAIN_PAGE_TITLE')}
      </div>
      <div className={s.subTitle}>
        {isRetrieveData
          ? t('OMI_DATA_DOWNLOAD_RETRIEVE_SUBTITLE')
          : t('DUET_H5_ACCOUNT_MANAGE_MAIN_PAGE_SUBTITLE')}
      </div>
      {isRetrieveData && (
        <div className={s.descBox}>
          <p>{t('OMI_DATA_DOWNLOAD_RETRIEVE_DESC')}</p>
          <p>
            To learn more, see our{' '}
            <Link href="/privacy" target="_blank" className={s.privacyLink}>
              Privacy Policy
            </Link>
            .
          </p>
        </div>
      )}
      <div className={s.btnsWrapper}>
        <div className={s.btnWrapper} onClick={() => handleEntry('phone')}>
          <div className={s.phoneIcon} />
          <div>
            {isRetrieveData
              ? t('OMI_DATA_DOWNLOAD_VERIFY_WITH_PHONE')
              : t('DUET_H5_ACCOUNT_MANAGE_MAIN_PAGE_PHONE_LOGIN')}
          </div>
        </div>
        <div className={s.btnWrapper}>
          <div className={s.googleIcon} />
          <div>
            {isRetrieveData
              ? t('OMI_DATA_DOWNLOAD_CONTINUE_GOOGLE')
              : t('DUET_H5_ACCOUNT_MANAGE_MAIN_PAGE_GOOGLE_LOGIN')}
          </div>
          <GoogleLoginButton {...props} isRetrieveData={isRetrieveData} />
        </div>
        <div className={s.btnWrapper}>
          <div className={s.appleIcon} />
          <div>
            {isRetrieveData
              ? t('OMI_DATA_DOWNLOAD_CONTINUE_APPLE')
              : t('OMI_LANDINGPAGE_SIGNIN_APPLE_NEW')}
          </div>
          <AppleLoginButton {...props} isRetrieveData={isRetrieveData} />
        </div>
      </div>
      <div className={s.termsWrapper}>
        <div>
          <Link href="/privacy" target="_blank">
            Privacy
          </Link>
        </div>
        <div>
          <Link href="/cookie-policy" target="_blank">
            Cookie Policy
          </Link>
        </div>
        <div>
          <Link href="/terms" target="_blank">
            Terms
          </Link>
        </div>
      </div>
    </div>
  );
}

export default observer(LogIn);
